import { css } from '@linaria/atomic';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';
import { Card } from './card';
import { CardProps } from './types';

const createEmailLandingDivStyle1 = css`
  margin-top: ${theme.spacing(3)};
`;

const createEmailLandingDivStyle2 = css`
  display: flex;
  gap: ${theme.spacing(3)};
  flex-wrap: wrap;
`;

const createEmailLandingNakedButtonStyle3 = css`
  margin-top: ${theme.spacing(2)};
`;

type Props = {
  cancelTrackingId: string;
  cards: CardProps[];
  onCancel: () => void;
};

export const CreateEmailLanding = ({ cancelTrackingId, cards, onCancel }: Props) => {
  const { t } = useTranslation('messages');
  return (
    <div className={createEmailLandingDivStyle1}>
      <div className={createEmailLandingDivStyle2}>
        {cards.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
      <NakedButton className={createEmailLandingNakedButtonStyle3} onClick={onCancel} trackingId={cancelTrackingId}>
        <Text color='primary' weight='bold'>
          {t('Cancel')}
        </Text>
      </NakedButton>
    </div>
  );
};
